<template>
    <el-dialog :title="$t('shared.changePassword')" :visible.sync="showDialog" @close="closeDialog" width="300px" class="change-password-dilog" :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" size="small" label-position="top">
            <el-form-item :label="$t('shared.oldPassword')" prop="oldPassword">
                <el-input v-model="form.oldPassword" type="password"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shared.newPassword')" prop="newPassword">
                <el-input v-model="form.newPassword" type="password"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button :disabled="loading" @click="save" type="primary">{{$t('shared.change')}}</el-button>
            <el-button :disabled="loading" @click="closeDialog">{{$t('common.cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'change-password-dialog',
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: {
                    oldPassword: '',
                    newPassword: ''
                },
                rules: {
                    oldPassword: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterOldPassword'),
                            trigger: 'blur'
                        }
                    ],
                    newPassword: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterNewPassword'),
                            trigger: 'blur'
                        }
                    ]
                },
                showDialog: this.visible,
                loading: false
            }
        },
        watch: {
            visible: function (val) {
                this.showDialog = val
            }
        },
        methods: {
            closeDialog() {
                this.$refs['form'].resetFields()
                this.showDialog = false
                this.loading = false
                this.$emit('dialogClosed')
            },
            save() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.loading = true
                        axios.post('api/users/change', this.form).then((response) => {
                            this.loading = false
                            if (response.data.success) {
                                this.closeDialog()
                            } else {
                                this.$message.error(response.data.message);
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .change-password-dilog >>> .el-dialog__body {
        padding: 0 15px;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/shared/components/ChangePasswordDialog.vue